import { mapGetters, mapActions } from 'vuex'

// 入力ガイドの遷移先URLを登録
const mainUrl = "https://house.lowenergy.jp/dictionary/"
const guideUrl = {
    /* 基本情報 */
    'bsc_name': mainUrl + 'basic#bsc_name',
    'env_chiki': mainUrl + 'basic#env_chiki',
    'bsc_tatekata': mainUrl + 'basic#bsc_tatekata',
    'bsc_kyoshitsu_kousei': mainUrl + 'basic#bsc_kyoshitsu_kousei',
    'bsc_nobeyuka_menseki': mainUrl + 'basic#bsc_nobeyuka_menseki',
    'bsc_solarlv_specify': mainUrl + 'basic#bsc_solarlv_specify',
    /* 外皮 */
    'ip_houhou': mainUrl + 'envelope#ip_houhou',/* 外皮性能の評価方法 */
    'bsc_sougaihi_menseki': mainUrl + 'envelope#bsc_sougaihi_menseki',/* 外皮面積の合計 */
    'ip_u_value': mainUrl + 'envelope#ip_u_value',/* 外皮平均熱貫流率 */
    'ss_eta_value': mainUrl + 'envelope#ss_eta_value',/* 冷房期平均日射熱取得率 */
    'sw_eta_value': mainUrl + 'envelope#ss_eta_value',/* 暖房期平均日射熱取得率 */
    'ip_structure':mainUrl + 'envelope#ip_structure',/* 暖房期平均日射熱取得率 */
    'ip_yuka_dannetsu': mainUrl + 'envelope#ip_house_dannetsu',/* 住戸の種類（別途計算） */
    'ip_house_dannetsu': mainUrl + 'envelope#ip_house_dannetsu',/* 住戸の種類（ここで計算） */
    'ip_heat_transmission_coefficient': mainUrl + 'envelope#ip_u_roof',/* 屋根又は天井/壁/その他の床の熱貫流率    */
    'ip_u_roof': mainUrl + 'envelope#ip_u_roof',/* 屋根又は天井/壁/その他の床の熱貫流率 */
    'ip_u_wall': mainUrl + 'envelope#ip_u_roof',/* 屋根又は天井/壁/その他の床の熱貫流率 */
    'ip_u_door': mainUrl + 'envelope#ip_u_door',/* ドアの熱貫流率 */
    'ip_u_window': mainUrl + 'envelope#ip_u_window',/* 窓の熱貫流率 */
    'ip_u_floor_bath': mainUrl + 'envelope#ip_u_floor_bath',/* 浴室の床の熱貫流率 */
    'ip_u_floor_other': mainUrl + 'envelope#ip_u_roof',/* 屋根又は天井/壁/その他の床の熱貫流率 */
    'ip_u_base_etrc': mainUrl + 'envelope#ip_u_base_etrc',/* 基礎の熱貫流率/土間床等の外周部の線熱貫流率 */
    'ip_u_base_bath': mainUrl + 'envelope#ip_u_base_etrc',/* 基礎の熱貫流率/土間床等の外周部の線熱貫流率 */
    'ip_u_base_other': mainUrl + 'envelope#ip_u_base_etrc',/* 基礎の熱貫流率/土間床等の外周部の線熱貫流率 */
    'ip_psi_prm_etrc': mainUrl + 'envelope#ip_u_base_etrc',/* 基礎の熱貫流率/土間床等の外周部の線熱貫流率 */
    'ip_psi_prm_bath': mainUrl + 'envelope#ip_u_base_etrc',/* 基礎の熱貫流率/土間床等の外周部の線熱貫流率 */
    'ip_psi_prm_other': mainUrl + 'envelope#ip_u_base_etrc',/* 基礎の熱貫流率/土間床等の外周部の線熱貫流率 */
    'ip_psi_heatbridge_roof': mainUrl + 'envelope#ip_psi_heatbridge_roof',/* 熱橋の線熱貫流率 */
    'ip_psi_heatbridge_wall': mainUrl + 'envelope#ip_psi_heatbridge_roof',/* 熱橋の線熱貫流率 */
    'ip_psi_heatbridge_floor': mainUrl + 'envelope#ip_psi_heatbridge_roof',/* 熱橋の線熱貫流率 */
    'ip_psi_heatbridge_roof_wall': mainUrl + 'envelope#ip_psi_heatbridge_roof',/* 熱橋の線熱貫流率 */
    'ip_psi_heatbridge_wall_wall': mainUrl + 'envelope#ip_psi_heatbridge_roof',/* 熱橋の線熱貫流率 */
    'ip_psi_heatbridge_wall_floor': mainUrl + 'envelope#ip_psi_heatbridge_roof',/* 熱橋の線熱貫流率 */
    'ip_bath_dannetsu': mainUrl + 'envelope#ip_bath_dannetsu',/* 浴室の断熱構造 */
    'ip_ss_eta_d_window': mainUrl + 'envelope#ip_ss_eta_d_window',/* 冷房期の窓の垂直面日射熱取得率 */
    'ip_sw_eta_d_window': mainUrl + 'envelope#ip_ss_eta_d_window',/* 暖房期の窓の垂直面日射熱取得率 */
    'nw_ldk_houhou': mainUrl + 'envelope#ip_tsuuhuu',/* 通風の利用（主たる居室） */
    'nw_nldk_houhou': mainUrl + 'envelope#ip_tsuuhuu',/* 通風の利用（その他の居室） */
    'sh_nisshanetsuriyo': mainUrl + 'envelope#sh_nisshanetsuriyo',/* 蓄熱の利用 */
    'ip_ufv': mainUrl + 'envelope#ip_ufv',/* 床下空間を経由して外気を導入する換気方式の利用 */
    'ip_ufv_area_rate': mainUrl + 'envelope#ip_ufv_area_rate',/* 外気が経由する床下の面積の割合 */
    'ip_ufv_dannetsu': mainUrl + 'envelope#ip_ufv_dannetsu',/* 床下空間の断熱 */
    /* 暖房 */
    'hs_houhou': mainUrl + 'heating#hs_houhou',
    'hs_ldk_type': mainUrl + 'heating#hs_ldk_type',
    'hs_nldk_type': mainUrl + 'heating#hs_ldk_type',
    'hs_ldk_aircon_houhou': mainUrl + 'heating#hs_ldk_aircon_houhou',
    'hs_nldk_aircon_houhou': mainUrl + 'heating#hs_ldk_aircon_houhou',
    'hs_ldk_aircon_koukouritsu': mainUrl + 'heating#hs_ldk_aircon_koukouritsu',
    'hs_nldk_aircon_koukouritsu': mainUrl + 'heating#hs_ldk_aircon_koukouritsu',
    'hs_ldk_aircon_dualcompressor': mainUrl + 'heating#hs_ldk_aircon_dualcompressor',
    'hs_nldk_aircon_dualcompressor': mainUrl + 'heating#hs_ldk_aircon_dualcompressor',
    'hs_ldk_ff_houhou': mainUrl + 'heating#hs_ldk_ff_houhou',
    'hs_nldk_ff_houhou': mainUrl + 'heating#hs_ldk_ff_houhou',
    'hs_heater_fusetsu': mainUrl + 'heating#hs_heater_fusetsu',/* 敷設率 */
    'hs_ldk_racfh_fusetsu': mainUrl + 'heating#hs_heater_fusetsu',/* 敷設率 */
    'hs_nldk_racfh_fusetsu': mainUrl + 'heating#hs_heater_fusetsu',/* 敷設率 */
    'hs_nldk_heater_fusetsu': mainUrl + 'heating#hs_heater_fusetsu',/* 敷設率 */
    'hs_ldk_yuka_fusetsu': mainUrl + 'heating#hs_heater_fusetsu',/* 敷設率 */
    'hs_nldk_yuka_fusetsu': mainUrl + 'heating#hs_heater_fusetsu',/* 敷設率 */
    'hs_ldk_heater_fusetsu': mainUrl + 'heating#hs_heater_fusetsu',/* 敷設率 */

    'hs_ldk_heater_fukinuke': mainUrl + 'heating#hs_ldk_heater_fukinuke',/*仮想床の床面積を除いた敷設率*/
    'hs_ldk_racfh_fukinuke': mainUrl + 'heating#hs_ldk_heater_fukinuke',/*仮想床の床面積を除いた敷設率*/
    'hs_ldk_yuka_fukinuke': mainUrl + 'heating#hs_ldk_heater_fukinuke',/*仮想床の床面積を除いた敷設率*/

    'hs_ldk_heater_dannetsu': mainUrl + 'heating#hs_ldk_heater_dannetsu',/*上面放熱率（床の断熱）*/
    'hs_ldk_racfh_dannetsu': mainUrl + 'heating#hs_ldk_heater_dannetsu',/*上面放熱率（床の断熱）*/
    'hs_ldk_yuka_dannetsu': mainUrl + 'heating#hs_ldk_heater_dannetsu',/*上面放熱率（床の断熱）*/
    'hs_nldk_heater_dannetsu': mainUrl + 'heating#hs_ldk_heater_dannetsu',/*上面放熱率（床の断熱）*/
    'hs_nldk_racfh_dannetsu': mainUrl + 'heating#hs_ldk_heater_dannetsu',/*上面放熱率（床の断熱）*/
    'hs_nldk_yuka_dannetsu': mainUrl + 'heating#hs_ldk_heater_dannetsu',/*上面放熱率（床の断熱）*/

    'hs_onsuiyuka_netsugen': mainUrl + 'heating#hs_onsuiyuka_netsugen',/* 温水暖房機の種類 */
    'hs_onsuiyuka_netsugen_s': mainUrl + 'heating#hs_onsuiyuka_netsugen',/* 温水暖房機の種類 */
    'hs_onsuiyuka_gas1_houhou': mainUrl + 'heating#hs_onsuiyuka_gas1_houhou',/*エネルギー消費効率の入力（ガス従来型/ガス潜熱回収型/石油従来型） */
    'hs_onsuiyuka_gas2_houhou': mainUrl + 'heating#hs_onsuiyuka_gas1_houhou',/*エネルギー消費効率の入力（ガス従来型/ガス潜熱回収型/石油従来型） */
    'hs_onsuiyuka_oil_houhou': mainUrl + 'heating#hs_onsuiyuka_gas1_houhou',/*エネルギー消費効率の入力（ガス従来型/ガス潜熱回収型/石油従来型） */
    'hs_onsuiyuka_dannnetu': mainUrl + 'heating#hs_onsuiyuka_dannnetu',/*断熱配管 */
    'hs_ldk_racfh_dannetsu_haikan': mainUrl + 'heating#hs_onsuiyuka_dannnetu',/*断熱配管 */
    'hs_nldk_racfh_dannetsu_haikan': mainUrl + 'heating#hs_onsuiyuka_dannnetu',/*断熱配管 */
    'hs_onsuiyuka_dannnetu_kukaku': mainUrl + 'heating#hs_onsuiyuka_dannnetu_kukaku',
    'hs_onsuiyuka_hp_netsukoukan': mainUrl + 'heating#hs_onsuiyuka_hp_netsukoukan',
    'hs_type_1': mainUrl + 'heating#hs_type_1',
    'hs_dc_duct_dannnetu': mainUrl + 'heating#hs_dc_duct_dannnetu',
    'hs_dc_vav': mainUrl + 'heating#hs_dc_vav',
    'hs_dc_general_ventilation': mainUrl + 'heating#hs_dc_general_ventilation',
    'hs_dc_input': mainUrl + 'heating#hs_dc_input',
    'hs_dc_rated_capacity': mainUrl + 'heating#hs_dc_rated_capacity',
    'hs_dc_rated_power': mainUrl + 'heating#hs_dc_rated_power',
    'hs_dc_rated_air_flow': mainUrl + 'heating#hs_dc_rated_air_flow',
    'hs_dc_rated_fan_power': mainUrl + 'heating#hs_dc_rated_fan_power',
    'hs_dc_middle_capacity': mainUrl + 'heating#hs_dc_middle_capacity',
    'hs_dc_middle_power': mainUrl + 'heating#hs_dc_middle_power',
    'hs_dc_middle_air_flow': mainUrl + 'heating#hs_dc_middle_air_flow',
    'hs_dc_middle_fan_power': mainUrl + 'heating#hs_dc_middle_fan_power',
    'hs_dc_air_volume': mainUrl + 'heating#hs_dc_air_volume',
    /* 冷房 */
    'cs_houhou': mainUrl + 'cooling#cs_houhou',
    'cs_ldk_type': mainUrl + 'cooling#cs_ldk_type',
    'cs_nldk_type': mainUrl + 'cooling#cs_ldk_type',
    'cs_ldk_type1_houhou': mainUrl + 'cooling#cs_ldk_type1_houhou',
    'cs_nldk_type1_houhou': mainUrl + 'cooling#cs_ldk_type1_houhou',
    'cs_ldk_aircon_koukouritsu': mainUrl + 'cooling#cs_ldk_aircon_koukouritsu',
    'cs_nldk_aircon_koukouritsu': mainUrl + 'cooling#cs_ldk_aircon_koukouritsu',
    'cs_ldk_aircon_dualcompressor': mainUrl + 'cooling#cs_ldk_aircon_dualcompressor',
    'cs_nldk_aircon_dualcompressor': mainUrl + 'cooling#cs_ldk_aircon_dualcompressor',
    'cs_type': mainUrl + 'cooling#cs_type',
    'cs_dc_duct_dannnetu': mainUrl + 'cooling#cs_dc_duct_dannnetu',
    'cs_dc_vav': mainUrl + 'cooling#cs_dc_vav',
    'cs_dc_general_ventilation': mainUrl + 'cooling#cs_dc_general_ventilation',
    'cs_dc_input': mainUrl + 'cooling#cs_dc_input',
    'cs_dc_rated_capacity': mainUrl + 'cooling#cs_dc_rated_capacity',
    'cs_dc_rated_power': mainUrl + 'cooling#cs_dc_rated_power',
    'cs_dc_rated_air_flow': mainUrl + 'cooling#cs_dc_rated_air_flow',
    'cs_dc_rated_fan_power': mainUrl + 'cooling#cs_dc_rated_fan_power',
    'cs_dc_middle_capacity': mainUrl + 'cooling#cs_dc_middle_capacity',
    'cs_dc_middle_power': mainUrl + 'cooling#cs_dc_middle_power',
    'cs_dc_middle_air_flow': mainUrl + 'cooling#cs_dc_middle_air_flow',
    'cs_dc_middle_fan_power': mainUrl + 'cooling#cs_dc_middle_fan_power',
    'cs_dc_air_volume': mainUrl + 'cooling#cs_dc_air_volume',
    /* 換気 */
    'vn_houshiki': mainUrl + 'ventilation#vn_houshiki',
    'vn_duct_houhou': mainUrl + 'ventilation#vn_duct_houhou',
    'vn_duct_method': mainUrl + 'ventilation#vn_duct_method',
    'vn_other_houhou': mainUrl + 'ventilation#vn_other_houhou',
    'vn_other_houhou_2': mainUrl + 'ventilation#vn_other_houhou_2',
    'vn_freq': mainUrl + 'ventilation#vn_freq',
    'vn_e': mainUrl + 'ventilation#vn_e',
    /* 熱交換 */
    'hv_houshiki': mainUrl + 'heat-exchange#hv_houshiki',
    'hv_eff': mainUrl + 'heat-exchange#hv_eff',
    'hv_bal': mainUrl + 'heat-exchange#hv_bal',
    'hv_leak': mainUrl + 'heat-exchange#hv_leak',
    /* 給湯 */
    'hw_setti': mainUrl + 'hot-water#hw_setti',
    'hw_shurui': mainUrl + 'hot-water#hw_shurui',
    'hw_senyo_sr1_taisaku': mainUrl + 'hot-water#hw_senyo_sr1_taisaku',/* 効率の入力（共通） */
    'hw_senyo_sr2_taisaku': mainUrl + 'hot-water#hw_senyo_sr1_taisaku',/* 効率の入力（共通） */
    'hw_senyo_sr3_taisaku': mainUrl + 'hot-water#hw_senyo_sr1_taisaku',/* 効率の入力（共通） */
    'hw_senyo_sr4_taisaku': mainUrl + 'hot-water#hw_senyo_sr1_taisaku',/* 効率の入力（共通） */
    'hw_ittai_sr11_taisaku': mainUrl + 'hot-water#hw_senyo_sr1_taisaku',/* 効率の入力（共通） */
    'hw_ittai_sr12_taisaku': mainUrl + 'hot-water#hw_senyo_sr1_taisaku',/* 効率の入力（共通） */
    'hw_ittai_sr13_taisaku': mainUrl + 'hot-water#hw_ittai_sr13_taisaku',/* 効率の入力（共通） */
    'hw_ittai_sr14_taisaku': mainUrl + 'hot-water#hw_ittai_sr14_taisaku',/* 効率の入力（共通） */
    'hw_senyo_sr6_spec_method': mainUrl + 'hot-water#hw_senyo_sr6_spec_method',
    'hw_senyo_sr6_e': mainUrl + 'hot-water#hw_senyo_sr6_e',
    'hw_senyo_sr6_shinaban': mainUrl + 'hot-water#hw_senyo_sr6_shinaban',
    'hw_senyo_sr7_package_input': mainUrl + 'hot-water#hw_senyo_sr7_package_input',
    'hw_ittai_sr18_package_input': mainUrl + 'hot-water#hw_senyo_sr7_package_input',
    'hw_senyo_sr7_shinaban': mainUrl + 'hot-water#hw_senyo_sr7_shinaban',
    'hw_ittai_sr18_shinaban': mainUrl + 'hot-water#hw_senyo_sr7_shinaban',
    'hw_senyo_sr7_coolant_type': mainUrl + 'hot-water#hw_coolant_type',
    'hw_ittai_sr18_coolant_type': mainUrl + 'hot-water#hw_coolant_type',
    'hw_senyo_sr7_tank': mainUrl + 'hot-water#hw_tank',
    'hw_ittai_sr18_tank': mainUrl + 'hot-water#hw_tank',
    'hw_ittai_sr17_kubun': mainUrl + 'hot-water#hw_ittai_sr17_kubun',
    'hw_src_type': mainUrl + 'hot-water#hw_src_type',
    'hw_header_type': mainUrl + 'hot-water#hw_header_type',
    'hw_suisen': mainUrl + 'hot-water#hw_suisen',
    'hw_shower_suisen': mainUrl + 'hot-water#hw_suisen',
    'hw_senmen_suisen': mainUrl + 'hot-water#hw_suisen',
    'hw_daidokoro_temoto': mainUrl + 'hot-water#hw_daidokoro_temoto',
    'hw_daidokoro_yusen': mainUrl + 'hot-water#hw_daidokoro_yusen',
    'hw_senmen_yusen': mainUrl + 'hot-water#hw_daidokoro_yusen',
    'hw_shower_temoto': mainUrl + 'hot-water#hw_shower_temoto',
    'hw_shower_shoryuryo': mainUrl + 'hot-water#hw_shower_shoryuryo',
    'hw_yokuso_hoon': mainUrl + 'hot-water#hw_yokuso_hoon',
    /* 照明 */
    'ls_main_setti': mainUrl + 'lighting#ls_setti',/* 主たる居室の照明設備/その他の居室の照明設備/非居室の照明設備 */
    'ls_general_setti': mainUrl + 'lighting#ls_setti',/* 主たる居室の照明設備/その他の居室の照明設備/非居室の照明設備 */
    'ls_other_setti': mainUrl + 'lighting#ls_setti',/* 主たる居室の照明設備/その他の居室の照明設備/非居室の照明設備 */
    'ls_main_design': mainUrl + 'lighting#ls_design',/* 照明器具の種類 */
    'ls_general_device': mainUrl + 'lighting#ls_design',/* 照明器具の種類 */
    'ls_other_device': mainUrl + 'lighting#ls_design',/* 照明器具の種類 */
    'ls_main_multi': mainUrl + 'lighting#ls_multi',
    'ls_main_dimming': mainUrl + 'lighting#ls_dimming',
    'ls_general_dimming': mainUrl + 'lighting#ls_dimming',
    'ls_other_control': mainUrl + 'lighting#ls_other_control',
    /* 太陽光 */
    'pv_saiyou': mainUrl + 'PV#pv_saiyou',
    'pv_panelsuu': mainUrl + 'PV#pv_panelsuu',
    'pv_pcs_koritsu_e': mainUrl + 'PV#pv_pcs_koritsu_e',
    'pv_panel_youryo': mainUrl + 'PV#pv_panel_youryo',
    'pv_panel_shurui': mainUrl + 'PV#pv_panel_shurui',
    'pv_panel_setti': mainUrl + 'PV#pv_panel_setti',
    'pv_panel_houi': mainUrl + 'PV#pv_panel_houi',
    'pv_panel_keisha': mainUrl + 'PV#pv_panel_keisha',
    /* 太陽熱 */
    'sw_saiyou': mainUrl + 'solar#sw_saiyou',
    'sw_sr': mainUrl + 'solar#sw_sr',
    'sw_sr1_menseki': mainUrl + 'solar#sw_sr1_menseki',
    'sw_sr1_angle': mainUrl + 'solar#sw_angle',/* 集熱部の設置方位角 */
    'om_panel_houi': mainUrl + 'solar#sw_angle',/* 集熱部の設置方位角 */
    'sw_sr1_slope': mainUrl + 'solar#sw_slope',
    'sw_sr2_menseki': mainUrl + 'solar#sw_sr2_menseki',
    'sw_sr2_angle': mainUrl + 'solar#sw_angle',
    'sw_sr2_slope': mainUrl + 'solar#sw_slope',
    'sw_sr2_tankyouryo': mainUrl + 'solar#sw_sr2_tankyouryo',
    'om_saiyou': mainUrl + 'solar#om_saiyou',
    'om_panelsuu': mainUrl + 'solar#om_panelsuu',
    'om_fan_jirituunten': mainUrl + 'solar#om_fan_jirituunten',
    'om_fan_type': mainUrl + 'solar#om_fan_type',
    'om_fan_test': mainUrl + 'solar#om_fan_test',
    'om_pump_jirituunten': mainUrl + 'solar#om_pump_jirituunten',
    'om_tankyouryo': mainUrl + 'solar#om_tankyouryo',
    'om_ufv_area_rate': mainUrl + 'solar#om_ufv_area_rate',
    'om_ufv_dannetsu': mainUrl + 'solar#om_ufv_dannetsu',
    'om_panel_menseki': mainUrl + 'solar#om_panel_menseki',
    'om_panel_keisha': mainUrl + 'solar#sw_slope',
    'om_panel_input': mainUrl + 'solar#om_panel_input',
    'om_panel_d0': mainUrl + 'solar#om_panel_d0',
    'om_panel_d1': mainUrl + 'solar#om_panel_d1',
    'om_panel_mfan': mainUrl + 'solar#om_panel_mfan',
    /* コージェネ */
    'use_cogen': mainUrl + 'cogene#use_cogen',
    'cogen_package_input': mainUrl + 'cogene#cogen_package_input',
    'cogen_type': mainUrl + 'cogene#cogen_type',
    'cogen_reverse': mainUrl + 'cogene#cogen_reverse',
    'search_cogen_text': mainUrl + 'cogene#search_cogen_text',
    'cogen_houshiki': mainUrl + 'cogene#cogen_houshiki',
}

export default {
    data() {
        return {
            guideUrl: guideUrl,
        }
    },
    methods:{
        ...mapActions('help', [
            'setHelp',
            'changeHelp'
        ]),
        /**
         * 受け取った名称に応じたヘルプを表示
         */
        helpView(name){
            this.setHelp(name)
            this.changeHelp()
        },
        helpHide(){
            this.changeHelp()
        },
        /**
         * 受け取った名称に応じて、住宅に関する省エネルギー基準に準拠したプログラムまとめページの入力ガイドを表示
         */
        guideTransition(name){
            if(this.guideUrl[name]){
                /* 入力ガイドを新しいタブで表示する */
                window.open(this.guideUrl[name], 'guide');
            }else{
                this.setHelp(name)
                this.changeHelp()
            }
        }
     },
     computed:{
        ...mapGetters('help', {
            showHelp:'getShowHelp',
            helpTitle:'getHelpTitle',
            helpText:'getHelpText',
            referenceTitle:'getReferenceTitle',
            referenceText:'getReferenceText',
        }),
     }
}
